import axios from 'axios';

export default {
    pre_insercion(p_email, p_usuario) {
		return axios
			.post('spoc/modppentry', {
				"p_email": p_email,
				"p_metodo": "pkg_compp_infatradius.pre_insercion",
				"p_args_in": JSON.stringify({
                    "p_usuario": p_usuario
				  })
			})
	},

	recuperar_AprobLinea(p_email, p_usuario){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_infatradius.recuperar_AprobLinea",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario
				})
		})
	},

	recuperar_Prima(p_email, p_usuario, p_moneda, p_desde, p_hasta){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_infatradius.recuperar_Prima",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_moneda": p_moneda,
				"p_desde": p_desde,
				"p_hasta": p_hasta
				})
		})
	}, 
	recuperar_SiniExcel(p_email, p_usuario, p_desde, p_hasta){
		return axios
		.post('spoc/modppentry', {
			"p_email": p_email,
			"p_metodo": "pkg_compp_infatradius.recuperar_SiniExcel",
			"p_args_in": JSON.stringify({
				"p_usuario": p_usuario,
				"p_desde": p_desde,
				"p_hasta": p_hasta
				})
		})
	},
	
}